/* eslint-disable */
// M9 猫砂盆 运行状态配置，由根目录 猫砂盆_m9.json 物模型生成，勿手工修改
export default [
  {
    "key": "rssi",
    "name": "WiFi信号强度",
    "type": "int",
    "unit": ""
  },
  {
    "key": "trashCanOverWeight",
    "name": "废物仓超重阈值",
    "type": "int",
    "unit": ""
  },
  {
    "key": "deviceServiceMode",
    "name": "设备运行状态",
    "type": "enum",
    "map": {
      "1": "空闲中",
      "2": "归位中",
      "3": "抚平中",
      "4": "清理中",
      "5": "倒沙中",
      "6": "猫咪出没",
      "7": "暂停中",
      "8": "错误中",
      "9": "称重恢复中",
      "10": "检测到活物",
      "11": "初始化中",
      "12": "已关机"
    }
  },
  {
    "key": "devMode",
    "name": "设备模式",
    "type": "enum",
    "map": {
      "0": "PCBA",
      "1": "生产工位1",
      "2": "生产工位2",
      "3": "生产工位3",
      "10": "待烧录SN",
      "11": "老化模式",
      "20": "用户模式"
    }
  },
  {
    "key": "trashCanWeight",
    "name": "废物箱重量",
    "type": "int",
    "unit": ""
  },
  {
    "key": "machineWeight",
    "name": "整机重量",
    "type": "int",
    "unit": ""
  },
  {
    "key": "childLockOnOff",
    "name": "童锁状态",
    "type": "enum",
    "map": {
      "0": "关",
      "1": "开"
    }
  },
  {
    "key": "cleanConfig",
    "name": "清理配置",
    "type": "struct",
    "fields": [
      {
        "key": "cleanType",
        "name": "清理模式",
        "type": "enum",
        "map": {
          "0": "手动清理",
          "1": "自动清理",
          "2": "幼猫模式"
        }
      },
      {
        "key": "smartOrPeriod",
        "name": "智能或周期清理",
        "type": "enum",
        "map": {
          "0": "智能清理",
          "1": "周期清理"
        }
      },
      {
        "key": "cleanTime",
        "name": "清理时间",
        "type": "int",
        "unit": ""
      }
    ]
  },
  {
    "key": "autoLevel",
    "name": "抚平配置",
    "type": "enum",
    "map": {
      "0": "关",
      "1": "开"
    }
  },
  {
    "key": "dumpConfig",
    "name": "倒沙配置",
    "type": "int",
    "unit": ""
  },
  {
    "key": "nowError",
    "name": "当前错误",
    "type": "enum",
    "map": {
      "0": "机器正常运转",
      "1": "电机堵转",
      "2": "电机丢脉冲",
      "3": "丢磁铁或霍尔",
      "4": "整机称重传感器异常",
      "5": "废物称重传感器异常",
      "6": "协处理器通讯异常",
      "7": "废物仓超重",
      "8": "整机超重",
      "9": "砂仓不在位",
      "10": "废物仓不在位",
      "11": "继电器控制失效",
      "12": "三元组烧录未完成",
      "13": "工位流程未完成",
      "14": "整机传感器标定异常",
      "15": "整机传感器标定未完成",
      "16": "废物仓标定未完成",
      "17": "废物仓标定异常",
      "18": "检测到活物"
    }
  },
  {
    "key": "NetWorkStatus",
    "name": "网络状态",
    "type": "struct",
    "fields": [
      {
        "key": "MAC_ADDR",
        "name": "MAC地址",
        "type": "text",
        "unit": ""
      },
      {
        "key": "IP_ADDR",
        "name": "IP地址",
        "type": "text",
        "unit": ""
      },
      {
        "key": "WIFI_RSSI",
        "name": "信号强度",
        "type": "int",
        "unit": ""
      },
      {
        "key": "WIFI_NAME",
        "name": "WIFI名称",
        "type": "text",
        "unit": ""
      }
    ]
  },
  {
    "key": "is12HourFormat",
    "name": "十二进制时间",
    "type": "enum",
    "map": {
      "0": "关",
      "1": "开"
    }
  },
  {
    "key": "trashCanPosi",
    "name": "废物仓在位",
    "type": "enum",
    "map": {
      "0": "不在位",
      "1": "在位"
    }
  },
  {
    "key": "catLitterMsg",
    "name": "猫砂信息",
    "type": "struct",
    "fields": [
      {
        "key": "catLitterType",
        "name": "猫砂类型",
        "type": "enum",
        "map": {
          "0": "种类1"
        }
      },
      {
        "key": "catLitterCoefficient",
        "name": "猫砂系数",
        "type": "int",
        "unit": ""
      }
    ]
  },
  {
    "key": "trashCanUsage",
    "name": "废物仓使用量",
    "type": "int",
    "unit": ""
  },
  {
    "key": "timeZoneMsg",
    "name": "时区信息",
    "type": "struct",
    "fields": [
      {
        "key": "timeZoneID",
        "name": "时区ID",
        "type": "text",
        "unit": ""
      },
      {
        "key": "zone",
        "name": "时区",
        "type": "int",
        "unit": ""
      },
      {
        "key": "dst",
        "name": "夏令时",
        "type": "enum",
        "map": {
          "0": "夏令时关闭",
          "1": "夏令时开启"
        }
      },
      {
        "key": "dstStartTimeOne",
        "name": "夏令时第一段开启时间戳",
        "type": "int",
        "unit": ""
      },
      {
        "key": "dstEndTimeOne",
        "name": "夏令时第一段停止时间戳",
        "type": "int",
        "unit": ""
      },
      {
        "key": "year",
        "name": "年份",
        "type": "int",
        "unit": ""
      },
      {
        "key": "dstStartTimeTwo",
        "name": "夏令时第二段开始时间戳",
        "type": "int",
        "unit": ""
      },
      {
        "key": "dstEndTimeTwo",
        "name": "夏令时第二段结束时间戳",
        "type": "int",
        "unit": ""
      }
    ]
  },
  {
    "key": "regionBaseurl",
    "name": "后端下发的设备区域服地址",
    "type": "text",
    "unit": ""
  },
  {
    "key": "timestamp",
    "name": "后端下发的时间戳",
    "type": "date",
    "unit": ""
  },
  {
    "key": "bRegionLock",
    "name": "区域锁",
    "type": "enum",
    "map": {
      "0": "无锁",
      "1": "锁区"
    }
  },
  {
    "key": "region",
    "name": "设备所在的区域",
    "type": "text",
    "unit": ""
  },
  {
    "key": "userOpenId",
    "name": "用户的阿里openId",
    "type": "text",
    "unit": ""
  },
  {
    "key": "GenHighSvcEnv",
    "name": "服务器环境",
    "type": "enum",
    "map": {
      "0": "正式环境",
      "1": "测试环境"
    }
  },
  {
    "key": "deviceAllStatus",
    "name": "设备所有状态",
    "type": "struct",
    "fields": [
      {
        "key": "trashCanInPosi",
        "name": "废物箱在位",
        "type": "enum",
        "map": {
          "0": "不在位",
          "1": "在位"
        }
      }
    ]
  },
  {
    "key": "deviceMsg",
    "name": "设备信息",
    "type": "struct",
    "fields": [
      {
        "key": "devMode",
        "name": "设备运行模式",
        "type": "enum",
        "map": {
          "0": "PCBA",
          "1": "工位1",
          "2": "工位2",
          "3": "工位3",
          "10": "四元组烧录",
          "11": "老化模式",
          "20": "用户模式"
        }
      },
      {
        "key": "devType",
        "name": "设备类型",
        "type": "enum",
        "map": {
          "0": "7dB500mA",
          "1": "无编码器电机",
          "2": "20dB1ALDO"
        }
      },
      {
        "key": "swVersion",
        "name": "软件版本",
        "type": "text",
        "unit": ""
      },
      {
        "key": "hwVersion",
        "name": "硬件版本",
        "type": "text",
        "unit": ""
      }
    ]
  },
  {
    "key": "copcMsg",
    "name": "协处理器信息",
    "type": "struct",
    "fields": [
      {
        "key": "version",
        "name": "软件版本",
        "type": "int",
        "unit": ""
      },
      {
        "key": "copcMode",
        "name": "模式",
        "type": "enum",
        "map": {
          "1": "IR开-继电器关",
          "2": "IR开-继电器开",
          "3": "IR关-继电器关",
          "4": "IR关-继电器开",
          "5": "IR开-继电器比较"
        }
      },
      {
        "key": "irThreshold",
        "name": "红外在位阈值",
        "type": "int",
        "unit": ""
      }
    ]
  },
  {
    "key": "silentMode",
    "name": "静音模式",
    "type": "enum",
    "map": {
      "0": "关",
      "1": "开"
    }
  },
  {
    "key": "motorStuckCur",
    "name": "电机堵转阈值",
    "type": "int",
    "unit": ""
  },
  {
    "key": "machineOverWeight",
    "name": "整机超重阈值",
    "type": "int",
    "unit": ""
  },
  {
    "key": "disconn",
    "name": "设备断连",
    "type": "struct",
    "fields": [
      {
        "key": "disconnReason",
        "name": "断连原因",
        "type": "int",
        "unit": ""
      },
      {
        "key": "reconnFailed",
        "name": "重连失败原因",
        "type": "int",
        "unit": ""
      },
      {
        "key": "rssi",
        "name": "信号强度",
        "type": "int",
        "unit": ""
      },
      {
        "key": "ts",
        "name": "断开时间",
        "type": "date",
        "unit": ""
      },
      {
        "key": "lockCnt",
        "name": "计数",
        "type": "int",
        "unit": ""
      }
    ]
  },
  {
    "key": "IR",
    "name": "红外检测值",
    "type": "int",
    "unit": ""
  },
  {
    "key": "activatedCarbonDaysLeft",
    "name": "活性炭剩余寿命",
    "type": "int",
    "unit": ""
  },
  {
    "key": "activatedCarbonLife",
    "name": "活性炭寿命",
    "type": "int",
    "unit": ""
  },
  {
    "key": "smoothAngle",
    "name": "抚平角度",
    "type": "int",
    "unit": ""
  },
  {
    "key": "DND_Mode",
    "name": "免打扰区间设置",
    "type": "struct",
    "fields": [
      {
        "key": "active",
        "name": "使能",
        "type": "enum",
        "map": {
          "0": "关",
          "1": "开"
        }
      },
      {
        "key": "startTime",
        "name": "开始时间秒数",
        "type": "int",
        "unit": "s"
      },
      {
        "key": "endTime",
        "name": "结束时间秒数",
        "type": "int",
        "unit": "s"
      },
      {
        "key": "weekRept",
        "name": "重复周期",
        "type": "text",
        "unit": ""
      }
    ]
  },
  {
    "key": "rebootReason",
    "name": "系统重启原因",
    "type": "enum",
    "map": {
      "1": "正常上电",
      "16": "OTA",
      "17": "命令重启",
      "18": "工厂重启",
      "19": "APP更新",
      "20": "睡眠唤醒",
      "21": "未知软件重启",
      "32": "掉电重启",
      "33": "看门狗重启",
      "34": "软件异常崩溃",
      "35": "ESP_RST_SW",
      "36": "未知原因"
    }
  },
  {
    "key": "unit_pref",
    "name": "用户偏好单位",
    "type": "enum",
    "map": {
      "0": "kg",
      "1": "lb"
    }
  },
  {
    "key": "bToiletReminder",
    "name": "如厕提醒开关",
    "type": "enum",
    "map": {
      "0": "关闭",
      "1": "开启"
    }
  },
  {
    "key": "weightSlope",
    "name": "称重K值",
    "type": "struct",
    "fields": [
      {
        "key": "trashCanSlope",
        "name": "废物仓称重斜率",
        "type": "double",
        "unit": ""
      },
      {
        "key": "machineSlope_k0",
        "name": "整机斜率K0",
        "type": "double",
        "unit": ""
      },
      {
        "key": "machineSlope_k1",
        "name": "整机斜率K1",
        "type": "double",
        "unit": ""
      },
      {
        "key": "machineSlope_k2",
        "name": "整机斜率K2",
        "type": "double",
        "unit": ""
      },
      {
        "key": "machineSlope_k3",
        "name": "整机斜率K3",
        "type": "double",
        "unit": ""
      }
    ]
  },
  {
    "key": "forceUpdateBase",
    "name": "强制更新基准值",
    "type": "int",
    "unit": ""
  },
  {
    "key": "provisioningConfig",
    "name": "配网身份信息",
    "type": "struct",
    "fields": [
      {
        "key": "region",
        "name": "设备区域",
        "type": "text",
        "unit": ""
      },
      {
        "key": "openId",
        "name": "身份标识",
        "type": "text",
        "unit": ""
      }
    ]
  },
  {
    "key": "toleranceHall",
    "name": "零点霍尔编码器范围",
    "type": "int",
    "unit": ""
  }
]


// WEBPACK FOOTER //
// ./src/js/m9RunStateConfig.js